import * as yup from "yup"
import type { NamedEntity } from "../../types"

export function initialValuesNamedEntity(namedEntity?: NamedEntity | undefined) {
  if (namedEntity) {
    return namedEntity
  }
  return {
    name: "",
    type: "",
  }
}

export function validationSchemaNamedEntity() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    type: yup.string().required("Campo obbligatorio"),
  })
}
